import { useClientPortalConfigContext } from "../context";

type AppointmentAction =
    | "GetLocations"
    | "GetServices"
    | "GetProviders"
    | "GetClients"
    | "GetDefaultGroupService"
    | "Schedule"
    | "Reschedule"
    | "GetAvailability"
    | "ValidateBooking";

const dataActions = ["GetLocations", "GetServices", "GetProviders", "GetClients", "GetDefaultGroupService"];
const appointmentActions = ["Schedule", "Reschedule", "GetAvailability", "ValidateBooking"];

export function useAppointmentBookingApi() {
    const { clientPortalGuid } = useClientPortalConfigContext();

    const getEndpoint = (action: AppointmentAction): string => {
        let controller: string;
        if (dataActions.includes(action)) {
            controller = "AppointmentData";
        } else if (appointmentActions.includes(action)) {
            controller = "Appointment";
        }

        return `/api/v1/${clientPortalGuid}/${controller}/${action}`;
    };

    return { getEndpoint };
}
